import { ERROR_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Error/config";
import { ERRORS_TRANSLATION_NAMESPACE } from "../../config";
import errorComponentsTranslations from "./components-error.es-ES.json";
import errorsTranslations from "./errors.es-ES.json";

export const esESTranslations = {
    [ERRORS_TRANSLATION_NAMESPACE]: errorsTranslations,
    [ERROR_COMPONENTS_TRANSLATION_NAMESPACE]: errorComponentsTranslations,
};
